export const menu = {
    label: 'Atendimentos',
    icon: 'pi pi-fw pi-book',
    to: '/nan/atendimentos',
    rules: ['NAN-ATENDIMENTOS-00'],
};
